var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurbhubPackagesDetailsBar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: "auto",
    viewBox: "0 0 18 141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_555",
    "data-name": "Grupo 555",
    transform: "translate(-20 -521)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_15",
    "data-name": "Elipse 15",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(20 521)",
    fill: "#7fc15e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_11",
    "data-name": "L\\xEDnea 11",
    y2: 133,
    transform: "translate(29 529)",
    fill: "none",
    stroke: "#7fc15e",
    strokeWidth: 2,
    strokeDasharray: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurbhubPackagesDetailsBar1);
export default __webpack_public_path__ + "static/media/curbhub_packages-details_bar_1.934eba0cc4f10c63ec7a3987b7d037df.svg";
export { ForwardRef as ReactComponent };